<template>
  <div
    class="billing-address"
    :class="{'md:tw-px-10 lg:tw-px-0': isOnboardingRedesign}"
  >
    <h3
      class="med-font"
      :class="{'tw-text-[2rem] !tw-font-atten': isOnboardingRedesign}"
    >
      Billing Address
    </h3>
    <b-row class="mt-4">
      <b-col>
        <label
          v-if="!isOnboardingRedesign"
          for="address1"
          class="input-label"
        >Street Address</label>
        <vue-google-autocomplete
          id="map"
          ref="streetAddress"
          classname="form-control"
          :placeholder="isOnboardingRedesign ? 'Street Address *' : 'Street Address'"
          :country="['us', 'pr']"
          class="fs-mask onboarding-input"
          :formatter="removeAccents"
          @placechanged="getAddressData"
          @inputChange="onStreetAddressInputChange"
          @change="onStreetAddressChange"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <label
          v-if="!isOnboardingRedesign"
          for="address2"
          class="input-label"
        >Apartment/Suite</label>
        <b-form-input
          v-model="billingaddress.address2"
          class="fs-mask onboarding-input"
          name="address2"
          placeholder="Apartment/Suite"
          :formatter="removeAccents"
          @input="fromAutocomplete = false"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <label
          v-if="!isOnboardingRedesign"
          for="city"
          class="input-label"
        >City</label>
        <b-form-input
          v-model="billingaddress.city"
          class="fs-mask onboarding-input"
          name="city"
          :placeholder="isOnboardingRedesign ? 'City *' : 'City'"
          :formatter="removeAccents"
          @input="fromAutocomplete = false"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col
        cols="12"
        :lg="isOnboardingRedesign ? 12 : 6"
      >
        <label
          v-if="!isOnboardingRedesign"
          for="state"
          class="input-label"
        >State</label>
        <b-form-select
          v-model="billingaddress.state"
          class="fs-mask onboarding-input"
          :class="{'state-select': billingaddress.state === ''}"
          :options="[{value: '', text: 'State*', disabled: true}, ...stateNames]"
          name="state"
          :placeholder="isOnboardingRedesign ? 'State *' : 'State'"
          @input="fromAutocomplete = false"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col
        cols="12"
        :lg="isOnboardingRedesign ? 12 : 6"
      >
        <label
          v-if="!isOnboardingRedesign"
          for="zipcode"
          class="input-label"
        >Zip Code</label>
        <b-form-input
          v-model="billingaddress.zipcode"
          class="fs-mask onboarding-input"
          name="zipcode"
          :placeholder="isOnboardingRedesign ? 'Zip Code *' : 'Zip Code'"
          @input="fromAutocomplete = false"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <label
          v-if="!isOnboardingRedesign"
          for="phoneno"
          class="input-label"
        >Phone</label>
        <b-form-input
          v-model="billingaddress.phoneno"
          class="fs-mask onboarding-input"
          name="phoneno"
          :placeholder="isOnboardingRedesign ? 'Phone Number *' : 'Phone No.'"
          :formatter="formatPhoneNumber"
          @input="fromAutocomplete = false"
        />
      </b-col>
    </b-row>

    <template v-if="isOnboardingRedesign">
      <div class="tw-mt-4 tw-mb-4 tw-flex tw-items-center tw-gap-2">
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.97266 14.2422C6.02018 14.2422 5.1224 14.0599 4.2793 13.6953C3.44076 13.3307 2.7002 12.8271 2.05762 12.1846C1.41504 11.542 0.911458 10.8014 0.546875 9.96289C0.182292 9.11979 0 8.22201 0 7.26953C0 6.31706 0.182292 5.42155 0.546875 4.58301C0.911458 3.73991 1.41276 2.99707 2.05078 2.35449C2.69336 1.71191 3.43392 1.20833 4.27246 0.84375C5.11556 0.479167 6.01335 0.296875 6.96582 0.296875C7.91829 0.296875 8.81608 0.479167 9.65918 0.84375C10.5023 1.20833 11.2451 1.71191 11.8877 2.35449C12.5303 2.99707 13.0339 3.73991 13.3984 4.58301C13.763 5.42155 13.9453 6.31706 13.9453 7.26953C13.9453 8.22201 13.763 9.11979 13.3984 9.96289C13.0339 10.8014 12.5303 11.542 11.8877 12.1846C11.2451 12.8271 10.5023 13.3307 9.65918 13.6953C8.82064 14.0599 7.92513 14.2422 6.97266 14.2422ZM6.97266 13.0801C7.7793 13.0801 8.53353 12.9297 9.23535 12.6289C9.93717 12.3281 10.5547 11.9134 11.0879 11.3848C11.6211 10.8516 12.0358 10.234 12.332 9.53223C12.6328 8.8304 12.7832 8.07617 12.7832 7.26953C12.7832 6.46289 12.6328 5.70866 12.332 5.00684C12.0312 4.30501 11.6143 3.6875 11.0811 3.1543C10.5524 2.62109 9.9349 2.20638 9.22852 1.91016C8.52669 1.60938 7.77246 1.45898 6.96582 1.45898C6.15918 1.45898 5.40495 1.60938 4.70312 1.91016C4.0013 2.20638 3.38607 2.62109 2.85742 3.1543C2.32878 3.6875 1.91406 4.30501 1.61328 5.00684C1.31706 5.70866 1.16895 6.46289 1.16895 7.26953C1.16895 8.07617 1.31706 8.8304 1.61328 9.53223C1.91406 10.234 2.32878 10.8516 2.85742 11.3848C3.39062 11.9134 4.00814 12.3281 4.70996 12.6289C5.41178 12.9297 6.16602 13.0801 6.97266 13.0801ZM6.96582 8.5C6.61491 8.5 6.4349 8.31999 6.42578 7.95996L6.33691 4.34375C6.33236 4.17057 6.38704 4.02702 6.50098 3.91309C6.61947 3.79915 6.77214 3.74219 6.95898 3.74219C7.14128 3.74219 7.29167 3.80143 7.41016 3.91992C7.5332 4.03385 7.59245 4.17741 7.58789 4.35059L7.48535 7.95996C7.48079 8.31999 7.30762 8.5 6.96582 8.5ZM6.96582 10.7217C6.7653 10.7217 6.59212 10.6533 6.44629 10.5166C6.30046 10.3753 6.22754 10.2067 6.22754 10.0107C6.22754 9.81478 6.30046 9.64844 6.44629 9.51172C6.59212 9.37044 6.7653 9.2998 6.96582 9.2998C7.16634 9.2998 7.33952 9.36816 7.48535 9.50488C7.63119 9.6416 7.7041 9.81022 7.7041 10.0107C7.7041 10.2113 7.62891 10.3799 7.47852 10.5166C7.33268 10.6533 7.16178 10.7217 6.96582 10.7217Z"
            fill="#1A6A72"
          />
        </svg>
        <div>
          Fields marked with<span class="tw-text-[#1A6A72] tw-px-0.5">*</span>are required.
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { LookUpService } from '@/services/lookup.service';
import mixins from '@/components/form/mixins';
import VueGoogleAutocomplete from 'vue-google-autocomplete';

export default {
  components: {
    VueGoogleAutocomplete,
  },
  mixins: [mixins],
  data() {
    return {
      selectedState: {},
      states: [],
      stateNames: [],
      billingaddress: {
        address1: '',
        address2: null,
        city: '',
        country: 'US',
        state: '',
        zipcode: null,
        phoneno: null,
      },
      fromAutocomplete: false,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  },
  async mounted() {
    const { data } = await LookUpService.getLookUp('state');
    this.states = data.map(state => ({
      value: state.id,
      text: state.name,
    }));
    for (const state of data) {
      this.stateNames.push(state.name);
    }
  },
  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    async getAddressData(addressData, placeResultData, id) {
      this.fromAutocomplete = true;
      if (addressData.street_number) {
        this.billingaddress.address1 = this.removeAccents(
          `${addressData.street_number} ${addressData.route}`
        );
      } else {
        this.billingaddress.address1 = this.removeAccents(addressData.route);
      }
      this.billingaddress.city = addressData.locality
        ? this.removeAccents(addressData.locality)
        : '';
      this.billingaddress.zipcode = addressData.postal_code
        ? addressData.postal_code
        : '';

      this.selectedState = this.states.find(
        state => state.value == addressData.administrative_area_level_1
      );
      this.billingaddress.state = this.selectedState.text;
    },
    onStreetAddressChange(val) {
      this.$refs.streetAddress.update(
        this.removeAccents(this.billingaddress.address1)
      );
    },
    onStreetAddressInputChange(val) {
      this.billingaddress.address1 = this.removeAccents(
        this.$refs.streetAddress.autocompleteText
      );
    },
  },
};
</script>

<style scoped>
::v-deep .custom-input-style .vs__dropdown-toggle {
  margin-top: 10px;
  border: 1px solid red;
}

.state-select[placeholder="State*"] {
  color: #B1C2D9;
}
</style>
